// extracted by mini-css-extract-plugin
export default {"form":"AppEditForm_form__Y0Cfe","buttonFormCancel":"AppEditForm_buttonFormCancel__r+X+o"};